import { takeLeading } from "@redux-saga/core/effects";
import { LogicActionTypes } from "./../types";
import { updateLogicData } from "./updateLogicRule";

export default function* RulesSaga() {
    yield takeLeading(LogicActionTypes.UPDATE_LOGIC_REQUEST, updateLogicData);
}
